import { createSlice } from "@reduxjs/toolkit";
import { getLoggedInUsers } from "./loggedInUsersActions";

const initialState = {
  loading: false,
  error: null,
  items: { results: [], meta: {} },
};

const loggedInUsersSlice = createSlice({
  name: "loggedInUsers",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoggedInUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLoggedInUsers.fulfilled, (state, { payload }) => {
        state.items = payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getLoggedInUsers.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { resetError } = loggedInUsersSlice.actions;
export default loggedInUsersSlice.reducer;
